export default __webpack_public_path__ + "static/media/partners-logo-zer-01-ne-w.21f1ce25.webp";